/*
 * @Description: home状态管理
 * @Author: 安知鱼
 * @Email: 2268025923@qq.com
 * @Date: 2021-08-30 10:27:31
 * @LastEditTime: 2022-03-06 17:43:28
 * @LastEditors: 安知鱼
 */
import { Module } from 'vuex'
import { ElMessage } from 'element-plus'

import {
  requestCarouselData,
  requestIntroductionData,
  requestProductResultData,
  requestPartnerData,
  requestRecruitmentData
} from '@/service/home/home'

import cifImg from '@/assets/img/services/cif.png'
import dapImg from '@/assets/img/services/dap.png'
import dduImg from '@/assets/img/services/ddu.png'
import fobImg from '@/assets/img/services/fob.png'

import { IHomeState } from './type'
import { IRootStore } from '../type'

// 产品与服务卡片图标硬编码映射（OSS 历史数据丢失，回退方案）
function resolveServiceImage(title: string): string | undefined {
  if (title === 'CIF服务') return cifImg
  if (title === 'DAP服务') return dapImg
  if (title === 'DDU服务') return dduImg
  if (title === 'FOB服务') return fobImg
  return undefined
}

const homeModule: Module<IHomeState, IRootStore> = {
  namespaced: true,
  state() {
    return {
      carouselData: [''],
      introductionInfo: { image: [] },
      productInfo: '',
      partnerInfo: {},
      recruitmentList: []
    }
  },
  mutations: {
    changeCarouselData(state, carouselData: string[]) {
      state.carouselData = carouselData
    },
    changeIntroductionInfo(state, introductionInfo: any) {
      state.introductionInfo = introductionInfo
    },
    changeProductInfo(state, productInfo: string[]) {
      state.productInfo = productInfo
    },
    changePartnerInfo(state, partnerInfo: string[]) {
      state.partnerInfo = partnerInfo
    },
    changeRecruitmentList(state, list: any[]) {
      state.recruitmentList = list
    }
  },
  actions: {
    async getCarouselData({ commit }) {
      const carouselResult = await requestCarouselData()
      if (carouselResult.code === '200') {
        const list = carouselResult.data?.list ?? []
        const mapped = list.map((item: any) => ({
          id: item.id,
          image: item.bannerUrl
        }))
        commit('changeCarouselData', mapped)
      } else {
        ElMessage.error({ message: '请求失败！', type: 'error' })
      }
    },

    async getIntroductionInfo({ commit }) {
      const introductionResult = await requestIntroductionData()
      if (introductionResult.code === '200') {
        const d = introductionResult.data ?? {}
        commit('changeIntroductionInfo', {
          text: d.content,
          image: [{ url: d.imageOne }, { url: d.imageTwo }]
        })
      } else {
        ElMessage.error({ message: '请求失败！', type: 'error' })
      }
    },

    async getProductInfo({ commit }) {
      const productResult = await requestProductResultData()
      if (productResult.code === '200') {
        const list = productResult.data?.list ?? []
        const mapped = list.map((item: any) => ({
          id: item.id,
          name: item.serveTitle,
          image: resolveServiceImage(item.serveTitle) || item.iconUrl,
          info: item.serveContent
        }))
        commit('changeProductInfo', mapped)
      } else {
        ElMessage.error({ message: '请求失败！', type: 'error' })
      }
    },

    async getPartnerInfo({ commit }) {
      const partnerResult = await requestPartnerData()
      if (partnerResult.code === '200') {
        const list = partnerResult.data?.list ?? []
        const partner = list
          .filter((item: any) => item.partnerType === 1)
          .map((item: any) => ({ id: item.id, image: item.partnerUrl }))
        const majorClient = list
          .filter((item: any) => item.partnerType === 2)
          .map((item: any) => ({ id: item.id, image: item.partnerUrl }))
        commit('changePartnerInfo', { partner, majorClient })
      } else {
        ElMessage.error({ message: '请求失败！', type: 'error' })
      }
    },

    async getRecruitmentList({ commit }) {
      const result = await requestRecruitmentData()
      if (result.code === '200') {
        const list = result.data?.list ?? []
        commit('changeRecruitmentList', list)
      }
    }
  }
}

export default homeModule
